import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Lang:
      localStorage.getItem('language') || process.env.VUE_APP_DEFAULT_LOCALE, // eslint-disable-line
  },
});

export default instance;
